import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { config } from 'config/config.js';
import { generateLocationLeftHand } from 'utils/utils'

import './CarouselContainer.scss';

export default class CardMake extends Component {
	handleClick(e) {
		e.preventDefault();
		if (this.props.onClick) {
			this.props.onClick()
		}
	}
	render() {

		if (this.props.url && this.props.img) {
      const dataQA = this.props.dataQA || undefined

			return (
				<a
          data-qa={dataQA}
					className={"CardMake" + (this.props.checked == true ? ' CardMake--checked' : '') + (this.props.disabled ? ' CardMake--disabled' : '')}
					style={{ backgroundImage: `url(` + this.props.img + `)` }}
					title={this.props.make + (this.props.disabled ? ' - Indisponível para os filtros selecionados' : '')}
					onClick={!this.props.disabled ? this.handleClick.bind(this) : 0}
					href={!this.props.disabled ? this.props.url : '/'}
				>
					<small className={'CardMake__name-make'}>{this.props.make}</small>
				</a>
			)
		}
		return false
	}
}
